import { SkeletonTheme } from "react-loading-skeleton";
import { ProductCard } from "@/components/product-card";
import { ProductCardSkeleton } from "@/components/layout/search/filter/filter-skeleton";
import { NOT_IMAGE } from "@/lib/constants";
import type { ProductDetailsInfo } from "@/lib/bagisto/types";

interface ProductGridProps {
  products: ProductDetailsInfo[];
  isLoading?: boolean;
}

const SKELETON_COUNT = 5;

export default function ProductGrid({ products, isLoading = false }: ProductGridProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full">
      {isLoading ? (
        <SkeletonTheme baseColor="#E9EAED" highlightColor="#ffffff">
          {Array.from({ length: SKELETON_COUNT }, (_, i) => (
            <ProductCardSkeleton key={i} />
          ))}
        </SkeletonTheme>
      ) : products.length > 0 ? (
        products.map((product) => (
          <ProductCard
            key={product.id}
            variant="default"
            imageUrl={product.images?.[0]?.url ?? NOT_IMAGE}
            product={{
              id: product.id,
              urlKey: product.urlKey,
              name: product.name,
              type: product.type ?? "simple",
            }}
          />
        ))
      ) : (
        <div className="col-span-full text-center py-20">
          <p className="text-neutral-300 text-lg">
            No products found in this category
          </p>
        </div>
      )}
    </div>
  );
}